export const data = {
  portrait: require("./assets/imgs/images/animacion-yoInv.gif"),
  instagram: require("./assets/imgs/triangle.svg"),
  artworks: [
    {
      pic: require("./assets/imgs/images/2.jpg"),
      thumb: require("./assets/imgs/thumbs/t2.jpg"),
      description: "Sin Título - Auto Heimlich - 60x90cms - 2019",
    },
    {
      pic: require("./assets/imgs/images/1.jpg"),
      thumb: require("./assets/imgs/thumbs/t1.jpg"),
      description: "Sin Título - Acrílico sobre tela - 120x90cms - 2014",
    },
    {
      pic: require("./assets/imgs/images/6.jpg"),
      thumb: require("./assets/imgs/thumbs/t6.jpg"),
      description:
        "Grupo al Aire Libre - Acrílico sobre tela - 130x95cms - 2023",
    },
    {
      pic: require("./assets/imgs/images/3.jpg"),
      thumb: require("./assets/imgs/thumbs/t3.jpg"),
      description: "Sin Título - Acrílico sobre tela - 120x120cms - 2015",
    },
    {
      pic: require("./assets/imgs/images/4.jpg"),
      thumb: require("./assets/imgs/thumbs/t4.jpg"),
      description: "Sin Título - Acrílico sobre tela - 100x100cms - 2014",
    },
    {
      pic: require("./assets/imgs/images/11.jpg"),
      thumb: require("./assets/imgs/thumbs/t11.jpg"),
      description: "Sin Título - Acrílico sobre tela - 100x100cms - 2024",
    },
    {
      pic: require("./assets/imgs/images/7.jpg"),
      thumb: require("./assets/imgs/thumbs/t7.jpg"),
      description: "Sin Título - Acrílico sobre tela - 70x90cms - 2017",
    },
    {
      pic: require("./assets/imgs/images/9.jpg"),
      thumb: require("./assets/imgs/thumbs/t9.jpg"),
      description: "Dos Mujeres - Acrílico sobre tela - 90x60cms - 2023",
    },
    {
      pic: require("./assets/imgs/images/10.jpg"),
      thumb: require("./assets/imgs/thumbs/t10.jpg"),
      description: "Sin Título - Acrílico sobre tela - 90x60cms - 2019",
    },
    {
      pic: require("./assets/imgs/images/5.jpg"),
      thumb: require("./assets/imgs/thumbs/t5.jpg"),
      description: "Sin Título - Acrílico sobre tela - 60x90cms - 2023",
    },
    {
      pic: require("./assets/imgs/images/12.jpg"),
      thumb: require("./assets/imgs/thumbs/t12.jpg"),
      description: "Sin Título - Acrílico sobre tela - 100x100cms - 2024",
    },
    {
      pic: require("./assets/imgs/images/13.jpg"),
      thumb: require("./assets/imgs/thumbs/t13.jpg"),
      description: "Sin Título - Acrílico sobre tela - 130x95cms - 2024",
    },
    {
      pic: require("./assets/imgs/images/14.jpg"),
      thumb: require("./assets/imgs/thumbs/t14.jpg"),
      description: "Sin Título - Acrílico sobre tela - 60x60cms - 2016",
    },
    {
      pic: require("./assets/imgs/images/15.jpg"),
      thumb: require("./assets/imgs/thumbs/t15.jpg"),
      description: "Sin Título - Acrílico sobre tela - 100x100cms - 2018",
    },
    {
      pic: require("./assets/imgs/images/16.jpg"),
      thumb: require("./assets/imgs/thumbs/t16.jpg"),
      description: "Sin Título - Acrílico sobre tela - 90x70cms - 2018",
    },
    {
      pic: require("./assets/imgs/images/17.jpg"),
      thumb: require("./assets/imgs/thumbs/t17.jpg"),
      description: "Sin Título - Acrílico sobre tela - 130x70cms - 2014",
    },
    {
      pic: require("./assets/imgs/images/18.jpg"),
      thumb: require("./assets/imgs/thumbs/t18.jpg"),
      description: "Sin Título - Acrílico sobre tela - 100x100cms - 2014",
    },
    {
      pic: require("./assets/imgs/images/19.jpg"),
      thumb: require("./assets/imgs/thumbs/t19.jpg"),
      description: "Sin Título - Acrílico sobre tela - 42x47cms - 2015",
    },
    {
      pic: require("./assets/imgs/images/20.jpg"),
      thumb: require("./assets/imgs/thumbs/t20.jpg"),
      description: "Sin Título - Acrílico sobre tela - 60x90cms - 2014",
    },
    {
      pic: require("./assets/imgs/images/21.jpg"),
      thumb: require("./assets/imgs/thumbs/t21.jpg"),
      description: "Diorama - Acrílico sobre tela - 100x100cms - 2024",
    },
    {
      pic: require("./assets/imgs/images/22.jpg"),
      thumb: require("./assets/imgs/thumbs/t22.jpg"),
      description: "Sin Título - Acrílico sobre tela - 90x60cms - 2019",
    },
    {
      pic: require("./assets/imgs/images/23.jpg"),
      thumb: require("./assets/imgs/thumbs/t23.jpg"),
      description: "Sin Título - Acrílico sobre tela - 90x60cms - 2020",
    },
    {
      pic: require("./assets/imgs/images/24.jpg"),
      thumb: require("./assets/imgs/thumbs/t24.jpg"),
      description: "Sin Título - Acrílico sobre tela - 90x60cms - 2020",
    },
    {
      pic: require("./assets/imgs/images/25.jpg"),
      thumb: require("./assets/imgs/thumbs/t25.jpg"),
      description: "Sin Título - Acrílico sobre tela - 47x42cms - 2020",
    },
    {
      pic: require("./assets/imgs/images/8.jpg"),
      thumb: require("./assets/imgs/thumbs/t8.jpg"),
      description: "Diorama - Acrílico sobre tela - 100x100cms - 2024",
    },
    {
      pic: require("./assets/imgs/images/26.jpg"),
      thumb: require("./assets/imgs/thumbs/t26.jpg"),
      description: "María - Acrílico sobre tela - 30x20cms - 2022",
    },
    {
      pic: require("./assets/imgs/images/27.jpg"),
      thumb: require("./assets/imgs/thumbs/t27.jpg"),
      description: "Sin Título - Acrílico sobre tela - 70x130cms - 2018",
    },
    {
      pic: require("./assets/imgs/images/28.jpg"),
      thumb: require("./assets/imgs/thumbs/t28.jpg"),
      description: "Sin Título - Acrílico sobre tela - 150x120cms - 2018",
    },
    {
      pic: require("./assets/imgs/images/29.jpg"),
      thumb: require("./assets/imgs/thumbs/t29.jpg"),
      description: "Sin Título - Acrílico sobre tela - 100x100cms - 2018",
    },
    {
      pic: require("./assets/imgs/images/30.jpg"),
      thumb: require("./assets/imgs/thumbs/t30.jpg"),
      description: "Anteojos - Acrílico sobre tela - 47x42cms - 2017",
    },
  ],
};
